import { Reminder } from '@app/features/reminder/types';
import {
  CONTRACT_SETUP_ALL_STATE_CLEAR,
  CONTRACT_SETUP_CLEAR_REMINDER,
  CONTRACT_SETUP_CREATE_REMINDER,
  CONTRACT_SETUP_DELETE_REMINDER,
  CONTRACT_SETUP_UPDATE_REMINDER,
} from '@app/store/actionTypes';
import { ContractSetupAction } from '@app/store/contract-setup/actions';

interface ContractSetupReminderState {
  reminders: Reminder[];
}

const initialState: ContractSetupReminderState = {
  reminders: [],
};

export default function reducer(
  state: ContractSetupReminderState = initialState,
  action: ContractSetupAction
): ContractSetupReminderState {
  switch (action.type) {
    case CONTRACT_SETUP_ALL_STATE_CLEAR:
    case CONTRACT_SETUP_CLEAR_REMINDER:
      return initialState;
    case CONTRACT_SETUP_CREATE_REMINDER:
      return {
        reminders: [...state.reminders, action.payload],
      };
    case CONTRACT_SETUP_DELETE_REMINDER:
      return {
        reminders: state.reminders.filter((reminder) => reminder.id !== action.payload.id),
      };
    case CONTRACT_SETUP_UPDATE_REMINDER:
      return {
        reminders: state.reminders.map((reminder) =>
          reminder.id === action.payload.id ? action.payload : reminder
        ),
      };
    default:
      return state;
  }
}
